import React from 'react';
import { css } from 'react-emotion';

import ReadOnlySvg from './ReadOnly.svg';

const ReadOnly = ({ message }) => (
  <div className={styles.wrapper}>
    <ReadOnlySvg />
    <p className={styles.text}>{message}</p>
  </div>
);

// TODO: Replace ProximaNova with font from @peachjar/components when that gets updated.
const styles = {
  text: css`
    max-width: 60%;
    text-align: center;
    color: #2d344b;
    padding: 2rem;
    font-size: 16px;
    font-family: 'Proxima Nova';
  `,
  wrapper: css`
    display: flex;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    background-color: #f5f5f5;
    padding: 4rem 2rem 2rem 2rem;
  `,
};

export default ReadOnly;



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/_shared/ReadOnly.jsx